import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { CounterFactory } from '../../factories/CounterFactory'
import { EditorComponentContract } from '../EditorComponentContract'

export class Counter extends EditorComponentContract {
	constructor() {
		super(Variations)
		this.htmlBuilder = HtmlBuilder
		this.factory = new CounterFactory
	}

	elementIds() {
		return ['id', 'containerId', 'counterId', 'titleId']
	}

	elementClasses() {
		return ['classes', 'containerClasses', 'counterClasses', 'titleClasses']
	}

	elementContents() {
		return ['text', 'hasPrefix', 'hasSuffix', 'hasTitle', 'prefix', 'suffix', 'counter', 'interval']
	}

	elementStyles() {
		return [
			{ id: 'id', element: 'id', styles: 'styles', selector: '#', variation: null },
			{ id: 'containerId', element: 'id', styles: 'containerStyles', selector: '#', variation: null },
			{ id: 'counterId', element: 'id', styles: 'counterStyles', selector: '#', variation: null },
			{ id: 'titleId', element: 'id', styles: 'titleStyles', selector: '#', variation: null },
		]
	}

	info() {
		return {
			name: 'Counter',
			icon: 'fa-sort-numeric-up-alt',
			variations: this.variationsInfo()
		}
	}
}
